
import * as handlebars_family from "../handlebars_family.js";
import "../widget/giphy.js";
const TPL = handlebars_family.addTemplate("form/post-gif",{"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"giphy\" data-widget=\"widget/giphy\"><form><span style=\"position:absolute;top:20px;left:15px;width:24px;height:24px;border-radius:50%;background:url('https://giphy.com/static/img/favicon.png') black no-repeat 50%\"></span><input type=\"text\" placeholder=\""
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"placeholders.giphy",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":262},"end":{"line":1,"column":293}}})) != null ? stack1 : "")
    + "\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"search") : depth0), depth0))
    + "\" style=\"padding-left:40px;\"></form><div class=\"giphy-img\"> &#160; </div></div>";
},"useData":true});
export default TPL;